import { Stack, Typography } from '@mui/material'

type Props = {
  firstName: string
}

export const WelcomeOverview = ({ firstName }: Props) => {
  return (
    <Stack className="gap-3">
      <Typography className="text-xl font-bold text-zWhite200">
        {`Vitajte${firstName ? `, ${firstName}` : ''}`}
      </Typography>
      <Typography className="text-3d font-normal text-zGrey400">
        Nižšie vás informujeme o stave vašho účtu a dôležitých upozorneniach.
      </Typography>
    </Stack>
  )
}
